
import { mapGetters } from 'vuex'
import { addBlankPath } from '@/utils/validate'
export default {
    name: 'LabelOrderMsg',
    inject: ['closeChat'],
    props: {
        message: {
            type: Object,
            default: () => { }
        }
    },
    data () {
        return {
        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo'
        }),
        picList () {
            const { value } = this.message.content.content
            return value.split(',')
        }
    },
    mounted () {

    },
    methods: {
        /**
         * 立即下单
         */
        async onBuyNow (message) {
            await this.$store.dispatch('user/UserGetInfo')
            if (!this.userinfo.isRealName) {
                this.$confirm('完成实名认证后再进行下单，是否前往？', '提示', {
                    confirmButtonText: '立即前往',
                    confirmButtonClass: 'confirmButtonClass',
                    type: 'error'
                })
                    .then(() => {
                        window.localStorage.setItem('realPath', this.$route.path)
                        addBlankPath('/account/realName')
                    })
                    .catch(_ => { })
                return
            }
            const { goodsNo, goodsCatalogueId, gameId, labelId } = message.content.content
            const data = {
                action: {
                    goodsNo,
                    labelId
                }
            }
            sessionStorage.setItem('orderDtl', JSON.stringify({ goodsNo, goodsCatalogueId, gameId }))
            this.$api.getGoodsPriceByLabel(data).then(res => {
                if (!res.data) {
                    this.$message({
                        message: res.info,
                        type: 'error'
                    })
                    return
                }
                this.closeChat() // 关闭聊天窗口
                const { price, compensation } = res.data
                this.$router.push({
                    path: '/confirmOrder/fullPayment',
                    query: {
                        orderType: 'LABEL',
                        goodsNo,
                        goodsCatalogueId,
                        gameId,
                        compensation,
                        labelId,
                        labelPrice: price,
                        status: 'null'
                    }
                })
            })
        }
    }
}
